import React from 'react';
import Icon from '../../../components/AppIcon';

const AlertPanel = ({ alerts }) => {
  const getPriorityColor = (priority) => {
    switch (priority) {
      case 'high': return 'border-l-error bg-error/5';
      case 'medium': return 'border-l-warning bg-warning/5';
      case 'low': return 'border-l-accent bg-accent/5';
      default: return 'border-l-muted bg-muted/5';
    }
  };

  const getPriorityIcon = (type) => {
    switch (type) {
      case 'risk': return 'AlertTriangle';
      case 'compliance': return 'Shield';
      case 'news': return 'Newspaper';
      case 'price': return 'TrendingUp';
      default: return 'Bell';
    }
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold text-foreground">Active Alerts</h3>
        <div className="flex items-center gap-2">
          <span className="text-sm text-muted-foreground">{alerts?.length} active</span>
          <Icon name="Settings" size={16} className="text-muted-foreground cursor-pointer hover:text-foreground" />
        </div>
      </div>
      <div className="space-y-3 max-h-80 overflow-y-auto">
        {alerts?.map((alert) => (
          <div 
            key={alert?.id} 
            className={`border-l-4 p-3 rounded-r-md ${getPriorityColor(alert?.priority)}`}
          >
            <div className="flex items-start gap-3">
              <Icon 
                name={getPriorityIcon(alert?.type)} 
                size={16} 
                className={`mt-0.5 ${
                  alert?.priority === 'high' ? 'text-error' : 
                  alert?.priority === 'medium' ? 'text-warning' : 'text-accent'
                }`} 
              />
              <div className="flex-1 min-w-0">
                <div className="flex items-center justify-between mb-1">
                  <h4 className="text-sm font-medium text-foreground truncate">{alert?.title}</h4>
                  <span className="text-xs text-muted-foreground whitespace-nowrap ml-2">
                    {alert?.timestamp}
                  </span>
                </div>
                <p className="text-sm text-muted-foreground">{alert?.message}</p>
                {alert?.action && (
                  <button className="text-xs text-accent hover:text-accent/80 mt-1 font-medium">
                    {alert?.action}
                  </button>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AlertPanel;